import { useMutation, useQuery } from '@tanstack/react-query';

import { askQuestion, createQuestionAnswer, getAskQuestionList } from '../functions/questionAnswer';

export const useAskQuestion = () =>
  useMutation({
    mutationFn: askQuestion,
    mutationKey: ['ask-question'],
    onError: (e: any) => {
      console.error('Error asking question', e);
    }
  });

export const useGetAsksQuestions = ({ npoId }: { npoId: string }) =>
  useQuery({
    queryKey: ['get-ask-questions', npoId],
    queryFn: () => getAskQuestionList({ npoId }),
    enabled: !!npoId
  });

export const useQuestionAnswer = () =>
  useMutation({
    mutationFn: createQuestionAnswer,
    mutationKey: ['create-question-answer']
  });
